'use client';
import { CartDrawer as SharedCartDrawer } from '@repo/ui/src/components/Cart';
import Cart from '@components/Cart';

export const CartDrawer = () => (
  <SharedCartDrawer cartPath="/cart">
    <Cart />
  </SharedCartDrawer>
);
